<h2 class="text-title mt-3" i18n>Review and Electronically Sign the Consultant Agreement</h2>
<h6 class="text-subtitle1 pr-3 pr-md-0" i18n>
    To proceed with your application, please review and electronically sign the Consultant Agreement using the Seguridata app below. When you are finished, the purple submit button at the bottom of the page will unlock so you can submit the application to Princess House.
</h6>
<h6 class="text-subtitle2 pr-3 pr-md-0" i18n>Please have your digital signature (firma digital) ready to sign the agreement electronically.</h6>

<app-saved-seguridata
    *ngIf="seguridataFormId"
    [seguridataFormId]="seguridataFormId"
    (resetSeguridataForm)="resetSeguridataForm()"
></app-saved-seguridata>

<ng-container *ngIf="idMissionTokenResponse && !seguridataFormId;">
    <form name="seguridataFormGroup" (ngSubmit)="onSeguridataFormSubmit()" target="iframe_idmission" [action]="sanitizedUrl" method="POST">
        <input id="tokenId" type="text" [value]="idMissionTokenResponse.tokenId" name="tokenId" size="20" [hidden] = "true"/>
        <input id="returnurl" type="text" [value]="idMissionTokenResponse.returnUrl" name="returnurl" size="20" [hidden] = "true"/>
        <input type="text" [value]="idMissionTokenResponse.requestId" name="requestId" id="requestId" size="20" [hidden] = "true"/>
        <input type="text" [value]="idMissionRegistrationResponse?.formId" name="formId" id="formId" size="20" [hidden] = "true"/>
        <input id="productId" type="text" [value]="productId" name="productId" size="20" [hidden] = "true"/><br/>
        <input id="FormData" type="text" [value]="idMissionTokenResponse.formData" name="FormData" size="100" [hidden] = "true"/>
        <input id="language" type="text" value="es_ES" name="language" size="5" [hidden] = "true"/>
        <button id="startBtn" type="submit" [hidden] = "true">Submit</button>
    </form>
    <div class="container-fluid px-2">
        <div class="embed-responsive embed-responsive-16by9">
            <iframe class="embed-responsive-item"
                sandbox="allow-same-origin allow-scripts allow-forms"
                name="iframe_idmission"
                [height]="getIframeHeight"
                allow="geolocation *; microphone *; camera *;">
            </iframe>
        </div>
    </div>
    <div class="validation-error-message col-12 mb-2" *ngIf="isSubmitted && isError;">
        {{ errorMessage }}
    </div>
</ng-container>

<div *ngIf="!idMissionTokenResponse && !seguridataFormId;">
    <img src="assets/images/misc/phLoading.gif" alt="loading" />
</div>



